import React, { useContext } from 'react'
import UserMenu from '../UserMenu/UserMenu'
import * as Styled from './GreetingStyles'
import { handleSignIn, OpenIDContext } from '../../api/openid'

const Greeting = ({ isAnimated }: GreetingProps) => {
	const { authenticated } = useContext(OpenIDContext)

	return (
		<Styled.StyledWrapperUserMenu
			className={`wrapper_usermenu ${isAnimated ? 'hide-login' : ''}`}
		>
			{authenticated && <UserMenu />}
			{!authenticated && (
				<Styled.SignInButton variant='outlined' onClick={handleSignIn}>
					Sign In
				</Styled.SignInButton>
			)}
		</Styled.StyledWrapperUserMenu>
	)
}

export default Greeting
